import React from "react";
import { DroneDTO } from "../../../../../store/drone_slice";
import Title from "../../../../../common/title/title";
import Input from "../../../../../common/input_text/input_text";

interface JobSuitabilityFormProps {
  droneData: Partial<Omit<DroneDTO, "id">>;
  updateDroneData: (newData: Partial<Omit<DroneDTO, "id">>) => void;
}

const JobSuitabilityForm: React.FC<JobSuitabilityFormProps> = ({
  droneData,
  updateDroneData,
}) => {
  const handleDescriptionChange = (value: string) => {
    updateDroneData({ description: value });
  };

  return (
    <div className="max-w-2xl mx-auto mt-8">
      <Title
        title="What makes you suitable for the job?"
        subtitle="More details, about your experience -> higher chance to be discovered"
      />
      <Input
        value={droneData.description || ""}
        onChange={handleDescriptionChange}
        placeholder="Write down your work experience"
        maxLength={500}
        isTextarea={true}
        rows={10}
      />
    </div>
  );
};

export default JobSuitabilityForm;
